

























































































































































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  watch,
  Ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';

import useAuth from '@/useAuth';

import getVehicle from '@/gql/vehicle/getVehicle.gql';
import deleteVehicle from '@/gql/vehicle/deleteVehicle.gql';
import createVehicle from '@/gql/vehicle/createVehicle.gql';
import updateVehicle from '@/gql/vehicle/updateVehicle.gql';
import restoreVehicle from '@/gql/vehicle/restoreVehicle.gql';
import uploadVehiclePicture from '@/gql/vehicle/uploadVehiclePicture.gql';
import getDrivers from '@/gql/driver/getDrivers.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonCheckboxIcon from '@/components/CommonCheckboxIcon.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';
import CommonPanelWithVehicleAbsenceLog from '@/components/Setting/CommonPanelWithVehicleAbsenceLog.vue';

const CommonFormWithVehicleEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonCheckboxIcon,
    GroupAddressEditor,
    CommonPanelWithVehicleAbsenceLog,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { me } = useAuth();
    const vehicle = reactive({
      id: -1,
      license: '',
      licenseProvince: '',
      model: '',
      color: '',
      year: '',
      fuelType: '',
      mile: 0,
      maxWidth: 0,
      maxLength: 0,
      maxHeight: 0,
      minWeight: 0,
      maxWeight: 0,
      vehicleType: 'PICKUP',
      active: false,
      vehicleWeight: 0,
      legalWeight: 0,

      avatarUrl: '',
      absenceLogs: [],

      defaultDriver: null,
      defaultDriverId: -1,

      deletedAt: '',
    });
    const { route } = useRouter();
    const { result: getOldVehicleResult, loading } = useQuery(getVehicle, computed(() => ({
      id: route.value.params.id,
      trashed: 'WITH',
    })), () => ({ fetchPolicy: 'network-only' }));
    const oldVehicleResult = useResult(getOldVehicleResult, {}, (data) => data.vehicle);
    watch(() => oldVehicleResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.edit) {
        vehicle.id = oldVehicleResult.value?.id || -1;
        vehicle.license = oldVehicleResult.value?.license || '';
        vehicle.licenseProvince = oldVehicleResult.value?.licenseProvince || '';
        vehicle.model = oldVehicleResult.value?.model || '';
        vehicle.color = oldVehicleResult.value?.color || '';
        vehicle.year = oldVehicleResult.value?.year || '';
        vehicle.fuelType = oldVehicleResult.value?.fuelType || '';
        vehicle.mile = oldVehicleResult.value?.mile || 0;
        vehicle.maxWidth = oldVehicleResult.value?.maxWidth || 0;
        vehicle.maxLength = oldVehicleResult.value?.maxLength || 0;
        vehicle.maxHeight = oldVehicleResult.value?.maxHeight || 0;
        vehicle.minWeight = oldVehicleResult.value?.minWeight || 0;
        vehicle.maxWeight = oldVehicleResult.value?.maxWeight || 0;
        vehicle.vehicleWeight = oldVehicleResult.value?.vehicleWeight || 0;
        vehicle.legalWeight = oldVehicleResult.value?.legalWeight || 0;
        vehicle.vehicleType = oldVehicleResult.value?.vehicleType || 0;

        vehicle.avatarUrl = oldVehicleResult.value?.avatarUrl || '';

        vehicle.absenceLogs = oldVehicleResult.value?.absenceLogs || '';

        vehicle.deletedAt = oldVehicleResult.value?.deletedAt || '';

        vehicle.defaultDriver = oldVehicleResult.value?.defaultDriver || null;
      }
    });

    const computedVehicleInput = computed(() => ({
      license: vehicle.license,
      licenseProvince: vehicle.licenseProvince,
      model: vehicle.model,
      vehicleType: vehicle.vehicleType,
      color: vehicle.color,
      year: vehicle.year,
      fuelType: vehicle.fuelType,
      mile: vehicle.mile,
      maxWidth: vehicle.maxWidth,
      maxLength: vehicle.maxLength,
      maxHeight: vehicle.maxHeight,
      minWeight: vehicle.minWeight,
      maxWeight: vehicle.maxWeight,
      vehicleWeight: vehicle.vehicleWeight,
      legalWeight: vehicle.legalWeight,
      defaultDriverId: parseInt((vehicle.defaultDriver as any)?.id, 10),

      defaultDriver: undefined,
      companyId: props.edit ? undefined : me.company.id,
    }));

    const refetchQueries = ['getVehicles', 'getVehicle'];
    const createVehicleMutation = useMutation(createVehicle, () => ({
      variables: {
        input: computedVehicleInput.value,
      },
      refetchQueries,
    }));
    const updateVehicleMutation = useMutation(updateVehicle, () => ({
      variables: {
        id: route.value.params.id,
        input: computedVehicleInput.value,
      },
      refetchQueries,
    }));
    const confirmModal = ref(null);
    createVehicleMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateVehicleMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createVehicleMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateVehicleMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.edit) return updateVehicleMutation;
      return createVehicleMutation;
    });

    const uploadVehiclePictureMutation = useMutation(uploadVehiclePicture, {
      refetchQueries,
    });
    const uploadVehiclePictureVariables = computed(() => {
      if (route.value.params.id !== null) return { id: route.value.params.id };
      return {};
    });

    const refetchQueriesList = [
      'getVehicles', 'getVehicle',
    ];
    const deleteVehicleModal = ref(null);
    const deleteVehicleMutation = useMutation(deleteVehicle, {
      refetchQueries: refetchQueriesList,
    });
    function deleteVehicleAction(vehicleId: number) {
      deleteVehicleMutation.mutate({
        id: vehicleId,
      });
    }

    const restoreVehicleMutation = useMutation(restoreVehicle, {
      refetchQueries: refetchQueriesList,
    });
    function restoreVehicleAction(vehicleId: number) {
      restoreVehicleMutation.mutate({
        id: vehicleId,
      });
    }

    // watch(() => route.name, (newVal: any, oldVal: any) => {
    //   if (newVal !== oldVal) {

    //   }
    // });

    return {
      me,
      vehicle,
      loading,

      computedMutation,

      confirmModal,
      errorModal,

      uploadVehiclePictureMutation,
      uploadVehiclePictureVariables,

      deleteVehicleModal,
      deleteVehicleMutation,
      deleteVehicleAction,

      restoreVehicleAction,

      getDrivers,
      getDriversResult: (data: any) => data.drivers.data,
    };
  },
});

export default CommonFormWithVehicleEditor;
